// extracted by mini-css-extract-plugin
module.exports = {"bar":"e_v-","seg":"e_w-","better":"e_x-","expected":"e_y-","worse":"e_z-","legend":"e_A-","legendItem":"e_B-","swatch":"e_C-"};